import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import { createClusterCustomIcon } from './styles';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import '../../styles/cluster.css';

var ClusterGroup =
/*#__PURE__*/
function (_Component) {
  _inherits(ClusterGroup, _Component);

  function ClusterGroup() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ClusterGroup);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ClusterGroup)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.render = function () {
      var _this$props = _this.props,
          onBounds = _this$props.onBounds,
          zoomLevel = _this$props.zoomLevel,
          children = _this$props.children;
      var childArray = React.Children.toArray(children);
      return React.createElement(MarkerClusterGroup, {
        disableClusteringAtZoom: 17,
        iconCreateFunction: createClusterCustomIcon
      }, React.Children.map((childArray || []).filter(function (ch) {
        return ch !== undefined && ch !== null && ch !== false;
      }), function (ch) {
        return React.cloneElement(ch, {
          onBounds: onBounds,
          zoomLevel: zoomLevel
        });
      }));
    }, _temp));
  }

  return ClusterGroup;
}(Component);

ClusterGroup.propTypes = {};
ClusterGroup.defaultProps = {};
export default ClusterGroup;